<template>
    <div :class="cls" :style="style">
        <div :style="middle">
            <slot :type="type"></slot>
            <slot v-if="isCourse" name='courseName' :course-name="courseName"></slot>
            <slot v-if="isCourse" name='className' :class-name="className"></slot>
        </div>
    </div>
</template>

<script>
    const CellTypes = {
        Course: 0,
        Transferred: 1,
        Booked: 2
    };
    export default {
        name: 'TimetableContent',
        props: {
            type: {
                type: Number,
                default: CellTypes.Course,
            },
            height: {
                type: Number,
                default: 100
            },
            width: {
                type: Number,
                default: 100
            },
            offsetTop: {
                type: Number,
                default: 0,
                required: true
            },
            offsetLeft: {
                type: Number,
                default: 0,
                required: true
            },
            isPast: {
                type: Boolean,
                default: false,
            },
            isNow: {
                type: Boolean,
                default: false,
            },
            isFuture: {
                type: Boolean,
                default: false,
            },
            cls:{
                type: String,
                default: ''
            },
            courseName:{
                type: String,
                default: ''
            },
            className:{
                type: String,
                default: ''
            }
        },

        computed: {
            style() {
                const {height, offsetTop, offsetLeft, width} = this;
                return {
                    display: `flex`,
                    justifyContent: `center`,
                    height: `${height}px`,
                    width: `${width}px`,
                    minHeight: `${height}px`,
                    top: `${offsetTop}px`,
                    left: `${offsetLeft}px`,
                    // lineHeight: `${height}px`
                }
            },
            middle() {
                const {width} = this;
                return {
                    width: `${width-40}px`,
                    alignSelf: `center`
                }
            },
            isCourse() {
                if (this.type === CellTypes.Course) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        watch:{

        },
        methods: {

        }
    }
</script>

<style>

</style>